<template>
   <div class="form-item g-select-box-container" :class="[dropdown ? 'g-select-active' : '', lighter ? 'lighter' : '']" v-click-outside="handlerClickOutside">
      <label class="g-select-box-label" :for="id" v-if="label">{{ label }}</label>

      <div class="g-select-box-wrapper">
         <div class="g-select-box" :class="lightTheme ? '' : ''" @click="dropdown = !dropdown">
            <div class="g-select-box-display">{{ TotalLength.length }} {{ $t("multiSelectComponent_itemSelected") }}</div>
            <i class="g-select-box-arrow gts-icon icon-arrow-down icon-xs"></i>
         </div>

         <div class="g-select-box-options-container" v-if="dropdown">
            <div class="search-box-container">
               <input type="text" v-model="search" />
               <div class="search-action-wrapper">
                  <i class="gts-icon icon-close-rounded gts-animation icon-xs" @click.self="handlerClearInput" v-if="search.length > 0"></i>
                  <button type="button" @click="handlerSelectAll(allSelectedProp)" :class="allSelectedProp ? 'deselectall' : 'selectall'">
                     {{ allSelectedProp ? $t("common_deselectAll") : $t("common_selectAll") }}
                  </button>
               </div>
            </div>
            <div class="g-select-box-options-inner-container">
               <div class="g-select-box-option" v-for="(option, index) in Options" :key="index" @click="handlerSelect(option)">
                  <span class="g-select-box-option-name" :class="option.selected ? 'is-selected' : ''" v-html="option.name"></span>
                  <span class="g-select-box-option-is-selected" v-if="option.selected"></span>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: "UIMultiSelect",
   props: {
      value: Array,
      label: String,
      id: String,
      options: Array,
      allowSearch: Boolean,
      lightTheme: Boolean,
      lighter: Boolean,
      mergeAllAsOne: Boolean,
      allSelected: Boolean,
   },
   data() {
      return {
         dropdown: false,
         search: "",
         selectList: [],
         allSelectedProp: false,
      };
   },
   mounted() {
      this.initializeSelectList();
   },
   computed: {
      Options() {
         if (this.search == "") {
            return this.selectList;
         } else {
            return this.selectList.filter((option) => option.name.toLowerCase().includes(this.search.toLowerCase()));
         }
      },
      TotalLength() {
         return this.selectList.filter((option) => option.selected == true);
      },
   },
   methods: {
      handlerSelect(option) {
         const idx = this.selectList.findIndex((item) => item.value === option.value && item.name === option.name);
         if (idx !== -1) {
            this.selectList[idx].selected = !this.selectList[idx].selected;
            this.updateAllSelectedProp();
            this.emitSelected();
         }
      },
      handlerClickOutside() {
         this.dropdown = false;
      },
      handlerClearInput() {
         this.search = "";
         this.dropdown = true;
      },
      handlerSelectAll(val) {
         this.allSelectedProp = !val;
         this.selectList.forEach((data) => {
            data.selected = this.allSelectedProp;
         });
         this.emitSelected();
      },
      initializeSelectList() {
         const valueArr = Array.isArray(this.value) ? this.value : [];
         this.selectList = this.options.map((option) => ({
            name: option.name,
            value: option.value,
            selected: valueArr.includes(option.value),
         }));
         this.updateAllSelectedProp();
      },
      updateAllSelectedProp() {
         this.allSelectedProp = this.selectList.length > 0 && this.selectList.every((item) => item.selected);
      },
      emitSelected() {
         let selectedValues = this.selectList.filter((o) => o.selected).map((o) => o.value);
         if (this.mergeAllAsOne && selectedValues.length === this.selectList.length) {
            selectedValues = [-1];
         }
         this.$emit("input", selectedValues);
         this.updateAllSelectedProp();
      },
   },
   watch: {
      options: {
         handler: function () {
            this.initializeSelectList();
         },
         deep: true,
         immediate: true,
      },
   },
};
</script>
<style lang="scss" scoped>
.g-select-box-container {
   width: 100%;

   .g-select-box-label {
      margin-bottom: 8px;
      font-weight: 500;
   }
   .g-select-box-wrapper {
      position: relative;
      .g-select-box {
         display: flex;
         flex-direction: row;
         align-items: center;
         justify-content: space-between;

         background: var(--gts-input-background) !important;
         border: 2px solid var(--gts-input-border) !important;
         padding: 0 0.75rem;
         box-sizing: border-box;
         border-radius: 0.5rem;
         min-height: 48px;
         cursor: pointer;

         .g-select-box-display {
            display: flex;

            span {
               color: var(--gray-700) !important;
            }
         }

         i.g-select-box-arrow {
            margin-left: 0.5rem;
         }
         i.flag-icon {
            margin-right: 0.5rem;
         }
      }
      .g-select-box-options-container {
         border: 1px solid var(--gray-300);
         background: var(--container-bg);
         position: absolute;
         border-radius: 0.5rem;
         left: 0;
         right: 0;
         z-index: 99;
         min-width: 200px;

         .search-box-container {
            position: relative;
            margin: 0 1rem;
            input {
               display: flex;
               align-items: center;
               justify-content: center;
               border: 2px solid var(--gts-input-border-lighter);
               background-color: var(--gts-input-background-lighter);
               color: var(--txt-color);
               border-radius: 24rem;
               box-sizing: border-box;
               overflow: hidden;
               margin: 0.5rem 0;
               height: 42px;
               width: 100%;
               text-indent: 0.5rem;
               outline: none !important;
               text-transform: capitalize;

               &:focus-visible {
                  border: 1px solid var(--accent-primary);
                  background-color: var(--accent-primary-lighter);
               }
            }

            .search-action-wrapper {
               position: absolute;
               display: flex;
               align-items: center;
               top: 0;
               bottom: 0;
               right: 0.5rem;
               margin: auto;

               button {
                  border-radius: 24rem;
                  font-weight: 500;
                  padding: 0.25rem 1rem;
                  border: none;
                  white-space: nowrap;
                  margin-left: 0.5rem;

                  &.selectall {
                     background-color: var(--primary);
                     //color: var(--gray-50);
                     color: var(--txt-white);
                  }
                  &.deselectall {
                     background-color: var(--gray-300);
                     color: var(--txt-color);
                  }
               }
            }
         }
         .g-select-box-options-inner-container {
            max-height: 300px;
            overflow: hidden;
            overflow-y: auto;

            .g-select-box-option {
               padding: 0.35rem 1.25rem;
               font-size: var(--small);
               color: var(--gray-700);
               display: flex;
               justify-content: space-between;
               align-items: center;
               border: 1px dotted var(--gray-200);
               &:hover {
                  background-color: var(--gray-100);
                  cursor: pointer;
               }

               .g-select-box-option-is-selected {
                  width: 14px;
                  height: 14px;
                  background: var(--primary);
                  outline: 3px solid var(--blue-100);
                  border-radius: 50%;
                  display: block;
               }
            }
         }
      }
   }

   &.g-select-active {
      .g-select-box-wrapper {
         .g-select-box {
            border: 1px solid var(--accent-primary);
            outline: 0.25rem solid var(--accent-primary-lighter);
            i.g-select-box-arrow {
               animation: rotation180 0.25s 1;
               animation-fill-mode: forwards;
               animation-timing-function: ease-in-out;
            }
         }
      }
   }

   &.lighter {
      .g-select-box-wrapper {
         .g-select-box {
            border: 2px solid var(--gts-input-border-lighter) !important;
            background: var(--gts-input-background-lighter) !important;
         }
      }
   }
}
</style>
